export default __webpack_public_path__ + "static/media/close-icon-flat.2e745359.svg";